"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFlex = void 0;
var _Flex = require("./Flex");
// TODO: in v9, move styled() from Flex.jsx to here
var StyledFlex = _Flex.Flex;
exports.StyledFlex = StyledFlex;